import { useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideBusinessAbstract, BusinessAbstractFormData } from './types'
import { AiInstructionFormData } from '../common/types'

export const useBusinessAbstractRegenerate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isRegenerating, setIsRegenerating] = useState(false)

  const regenerateBusinessAbstract = async (
    id: string,
    aiInstruction: string,
    setBusinessAbstract: (businessAbstract: SlideBusinessAbstract) => void,
    resetAiForm: (data: AiInstructionFormData) => void,
    resetForm: (data: BusinessAbstractFormData) => void
  ) => {
    if (!aiInstruction.trim() || !id) return

    setIsRegenerating(true)

    try {
      const response = await apiClient.business.slideAbstractRegenerateCreate({
        businessIdeaId: id,
        aiInstruction: aiInstruction,
      })

      if (response.data?.businessAbstract) {
        setBusinessAbstract(response.data.businessAbstract)
        resetAiForm({ aiInstruction: '' })
        showSnackBar(['事業概要のAI再生成が完了しました'], 'success', null) // 自動で消えない

        resetForm({
          projectName: response.data.businessAbstract.projectName,
          marketBackground: response.data.businessAbstract.sections.marketBackground,
          competitorAnalysis: response.data.businessAbstract.sections.competitorAnalysis,
          businessChance: response.data.businessAbstract.sections.businessChance,
          businessContentFirst: response.data.businessAbstract.sections.businessContentFirst,
          businessContentSecond: response.data.businessAbstract.sections.businessContentSecond,
        })
      }
    } catch (e) {
      console.error('事業概要のAI再生成に失敗しました:', e)
      handleError(e as ApiErrorResponse, (messages, severity) => {
        showSnackBar(messages, severity, null) // 自動で消えない
      })
    } finally {
      setIsRegenerating(false)
    }
  }

  return {
    isRegenerating,
    regenerateBusinessAbstract,
  }
}
